import React, { useState, useEffect } from "react";
import { CommonInput } from "@/components/ui/common-input";
import { CommonButton } from "@/components/ui/common-button";

const EditProductForm = ({ product, onUpdateProduct, onCancel, isSubmitting }) => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    unit_of_measure: ""
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (product) {
      setFormData({
        name: product.name || "",
        description: product.description || "",
        unit_of_measure: product.unitOfMeasure || ""
      });
    }
  }, [product]);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Product name is required";
    }

    if (!formData.description.trim()) {
      newErrors.description = "Description is required";
    }

    if (!formData.unit_of_measure.trim()) {
      newErrors.unit_of_measure = "Unit of measure is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));

    if (errors[field]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      const updatedProduct = {
        id: product.id,
        ...formData
      };

      onUpdateProduct(updatedProduct);
    }
  };

  if (!product) {
    return <div>Loading...</div>;
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="space-y-4">
        <CommonInput
          label="Product Name"
          id="name"
          value={formData.name}
          onChange={(e) => handleChange("name", e.target.value)}
          error={errors.name}
          required
          placeholder="Enter product name"
        />

        <CommonInput
          label="Description"
          id="description"
          value={formData.description}
          onChange={(e) => handleChange("description", e.target.value)}
          error={errors.description}
          required
          placeholder="Enter product description"
        />

        <CommonInput
          label="Unit of Measure"
          id="unit_of_measure"
          value={formData.unit_of_measure}
          onChange={(e) => handleChange("unit_of_measure", e.target.value)}
          error={errors.unit_of_measure}
          required
          placeholder="Enter unit of measure (e.g., kg, liters, pieces)"
        />
      </div>

      <div className="flex justify-end space-x-2 pt-5">
        <CommonButton
          type="button"
          variant="outline"
          onClick={onCancel}
          disabled={isSubmitting}
        >
          Cancel
        </CommonButton>
        <CommonButton 
          type="submit" 
          variant="default"
          loading={isSubmitting}
        >
          Update Product
        </CommonButton>
      </div>
    </form>
  );
};

export default EditProductForm;